const APPLY_DARK = "APPLY_DARK";
const APPLY_LIGHT = "APPLY_LIGHT";

export { APPLY_DARK, APPLY_LIGHT };
